export enum NotificationTypeEnum {
  error = 'error',
  info = 'info',
  success = 'success',
}
